import constConfig from '@/util/constConfig';
import service from '@/util/service';

// see Promise.all
export const syncAll = promises => service.all(promises);

// dict
export const getDict = params => service.jsonGet('/api/common/dictList', params);

export const getDictListByGroup = params => service.jsonGet('/api/common/dictListByGroup', params);

// redirect URL
export const captchaUrl = `${constConfig.axiosBaseURL}/api/captcha/kaptcha.jpg`;

export const uploadFileUrl = `${constConfig.axiosBaseURL}/api/attach/filePublicUpload`;

export const downloadFileUrl = `${constConfig.axiosBaseURL}/api/attach/download`;

export const imageView = `${constConfig.axiosBaseURL}/api/attach/image`;



// WEBPACK FOOTER //
// ./src/api/common.js